export default __webpack_public_path__ + "static/media/onboarding-aside-mb.bf5e2e46.png";